import React from "react";
import Barcode from "react-barcode";

export default function UiBarcode(props) {
    return (
        <>
            <Barcode value={props.value} />
        </>
    );
}
